/* !!!!!!!!!!!!!!!!!!!!!! */
/* !!! GENERATED FILE !!! */
/* !!!!!!!!!!!!!!!!!!!!!! */

import {
  ModuleDoneType,
  ModuleType,
  PlaniraPlanImage,
  type PlaniraTemplate,
} from "../../types";
import { PlanType } from "../../types";
import { PlanTemplateType } from "../template_types";

export const FlowPotluckTemplate: PlaniraTemplate = {
  type: PlanTemplateType.FlowPotluck,

  planType: PlanType.Quickstart,
  suggestedTitles: [
    "Bring Your Best Dish!",
    "Foodie Friends Unite!",
    "Let’s Feast Together!",
  ],
  title: "Potluck Dinner",
  description: "Organize a fun potluck dinner with friends.",
  longDescription:
    "Plan a delightful potluck dinner. Choose a date, coordinate dishes, and ensure everyone brings something tasty to share!",
  emoji: "🍽",
  titleHelp: "Change title or choose another:",
  imageType: PlaniraPlanImage.Party,

  sections: [
    {
      section: {
        isExpandable: false,
        isDraggable: false,
      },
      modules: [
        {
          type: ModuleType.PlanInfo,
          doneType: ModuleDoneType.None,
          title: "Potluck Dinner",
          emoji: "🍽",
        },
      ],
    },
    {
      section: {
        title: "Ongoing",
      },
      modules: [
        {
          type: ModuleType.Calendar,
          doneType: ModuleDoneType.Voting,
          title: "When should we have the potluck?",
          emoji: "📅",
          completeAction: {
            question: "Decide on dishes to bring?",
            description: "What dishes should we all contribute?",
            addModules: [
              {
                type: ModuleType.Poll,
                doneType: ModuleDoneType.Voting,
                title: "What dishes should we bring?",
                emoji: "🥘",
                completeAction: {
                  question: "Decide on drinks?",
                  description: "What drinks should we provide for the potluck?",
                  addModules: [
                    {
                      type: ModuleType.Poll,
                      doneType: ModuleDoneType.Voting,
                      title: "What drinks should we serve?",
                      emoji: "🍹",
                    },
                  ],
                },
              },
            ],
          },
        },
      ],
    },
  ],

  onTemplateComplete: {
    outroTitle: "Delicious Plans Ahead!",
    outroDescription:
      "Your potluck dinner plans are set! Enjoy the feast and fun!",
  },
};
